import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { ROUTE } from "../../../shared/utils/routes";
import { AuthService } from "../../services/auth/auth.service";

export function authenticatedGuardBuilder(options: {
  mustBeAuthenticated: boolean;
}): CanActivateFn {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const isAuthenticated = authService.isLoggedIn();
    const canActivate = options.mustBeAuthenticated
      ? isAuthenticated
      : !isAuthenticated;

    if (!canActivate) {
      const redirectRoute = options.mustBeAuthenticated
        ? ROUTE.AUTHENTICATION
        : ROUTE.AUTHENTICATED;
      return router.parseUrl(redirectRoute);
    }

    return true;
  };
}
